import { NgModule } from '@angular/core';
import { Textbox } from './textbox';
import { FormsModule } from '@angular/forms';
import { IconModule } from '../../icon/icon.module';
import { MatIconModule } from '@angular/material/icon';
import { MatTooltipModule } from '@angular/material/tooltip';

@NgModule({
    declarations: [Textbox],
    exports: [Textbox],
    imports: [FormsModule, IconModule, MatIconModule, MatTooltipModule],
})
export class TextboxModule {
}